import Icon from 'antd/lib/icon'
import styled from 'styled-components'
import { GRAY_DARK, GRAY_LIGHT, GRAY_LIGHTEST, GRAY_MEDIUM, RED } from '../../../../theme/colors'

interface ImagePreviewProps {
  src: string
}

export const StrongText = styled.div`
  color: ${GRAY_DARK};
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 10px;
  @media (max-width: 768px) {
    width: 50%;
  }
`

export const Text = styled.div`
  font-size: 16px;
  margin-bottom: 10px;
  &.items-count {
    display: flex;
    height: 19px;
    padding: 2px 8px;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    background: #F7F7F7;
    color: #8F8889;
    font-size: 11px;
    font-weight: 600;
  }
  @media (max-width: 768px) {
    width: 40%;
  }
`

export const PaletteName = styled.div``

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 120px;
  @media (max-width: 768px) {
    flex-direction: row;
    margin: 0;
    width: 100%;
  }
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  &.products-header {
    justify-content: space-between;
    border-bottom: 1px solid #D7D1D2;
    padding: 10px;
  }
`

export const LockerGrid = styled.div`
  max-width: 446px;
  width: 100%;
  padding-bottom: 38px;
`

export const EditButton = styled.div`
  color: ${RED};
  align-self: flex-end;
  margin-bottom: 10px;
  cursor: pointer;
`

export const Notes = styled.div`
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
`

export const Ideas = styled.div`
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
`

export const Inspiration = styled.div`
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  padding-inline: 10px;
`

export const Images = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  column-gap: 15px;
  row-gap: 10px;
  justify-items: flex-start;
  margin-top: 10px;
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  }
`

export const ImageContainer = styled.div`
  width: 110px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  @media (max-width: 768px) {
    width: 160px;
  }
`

export const Image = styled.div`
  background-size: cover;
  background-position: center;
  background-image: url('${({ src }: ImagePreviewProps) => src || ''}');
  width: 110px;
  height: 110px;
  @media (max-width: 768px) {
    width: 160px;
    height: 160px;
  }
  background-color: ${GRAY_LIGHT};
`

export const DocIcon = styled(Icon)`
  width: 110px;
  height: 110px;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 28px;
  color: ${GRAY_DARK};
  background: ${GRAY_LIGHTEST};
  @media (max-width: 768px) {
    width: 160px;
    height: 160px;
  }
`

export const LogoImage = styled.img`
  width: 110px;
  height: 110px;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 28px;
  color: ${GRAY_DARK};
  background: ${GRAY_LIGHTEST};
  padding: 34%;
  @media (max-width: 768px) {
    width: 160px;
    height: 160px;
  }
`

export const InspirationName = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 8px;
  font-size: 12px;
`

export const Color = styled.div`
  margin-bottom: 50px;
  padding-inline: 10px;
  display: flex;
  flex-direction: column;
`
export const Files = styled.div`
  margin-bottom: 50px;
  padding-inline: 10px;
  display: flex;
  flex-direction: column;
`

export const ImageText = styled.div`
  width: 100%;
  text-overflow: ellipsis;
  font-weight: 600;
  margin-top: 6px;
  overflow: hidden;
  white-space: nowrap;
`

export const Products = styled.div`
  font-family: "Avenir Next";
  margin-bottom: 50px;
  padding-inline: 10px;
  display: flex;
  flex-direction: column;
  &[data-product-list="true"] {
    padding-inline: 0;
    padding-top: 10px;
    border-radius: 8px;
    border: 1px solid #D7D1D2;
  }
`

export const Grid = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  .thumbnail-image {
    height: auto;
  }
`

export const ProductListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ProductList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-inline: 10px;
`

export const ProductItemCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 0;
  border-bottom: 1px solid ${GRAY_LIGHTEST};
  &:last-child {
    border-bottom: none;
  }
`

export const ProductItemTitle = styled.div`
  color: ${GRAY_DARK};
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 4px;
`

export const ProductItemType = styled.div`
  color: ${GRAY_MEDIUM};
  font-size: 14px;
  margin-bottom: 8px;
`

export const StatusPill = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  align-self: flex-start;
  border-radius: 25px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  background: #34c7591f;
  color: #2E7D32;
  i { 
    margin-right: 6px;
  }
  &.ourTeamWillDesign {
    background: #FFF8E1;
    color: #F57F17;
  }
`

export const ProductListFooter = styled.div`
  margin-top: 0;
  padding: 12px 16px;
  border-top: 1px solid ${GRAY_LIGHT};
  background: ${GRAY_LIGHTEST};
  border-radius: 0 0 8px 8px;
`

export const ProTipHeading = styled.span`
  font-weight: 600;
  color: ${GRAY_DARK};
  font-size: 14px;
`

export const ProTipBody = styled.p`
  margin: 4px 0 0;
  color: ${GRAY_DARK};
  font-size: 14px;
  line-height: 1.4;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/IntakeForm/Review/DataSelected/styledComponents.tsx